var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget__header"},[_c('h1',{class:_vm.headlineCssClasses},[_vm._v("\n    "+_vm._s(_vm.widget.title)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }